import { Utils, Logger } from "neo-common";
import { Platforms } from "neo-games";
import { AppContext } from "../../Common/AppContext";
import { Scaling } from "./Scaling";

/**
 * @class Focus
 */
export class Focus {
    static clicked: boolean = false;

    static focus(): void {
        window.onblur = Focus.onBlur;
        window.onfocus = Focus.onFocus;
        window.onclick = Focus.onClick;

        window.addEventListener("fullscreenchange", Focus.onFullscreenChange.bind(this));
    }

    static onClick(): void {
        if (
            AppContext.gameConfiguration &&
            AppContext.gameConfiguration.FullscreenOnClick &&
            !Scaling.IsIOs &&
            !Platforms.Platforms.handleFullscreen
        ) {
            if (document.body.requestFullscreen) {
                document.body.requestFullscreen();
            } else if (document.body.webkitRequestFullscreen) {
                document.body.webkitRequestFullscreen();
            }
        }

        if (!Focus.clicked) {
            Focus.clicked = true;
        }
    }

    static onFullscreenChange(e: Event): void {
        Platforms.Platforms.fullscreen(document.fullscreenElement != null);
    }

    static onFocus(): void {
        if (AppContext.gameConfiguration && AppContext.gameConfiguration.MuteOnLostFocus) {
            PIXI.sound.unmuteAll();
        }
    }

    static onBlur(): void {
        if (AppContext.gameConfiguration && AppContext.gameConfiguration.MuteOnLostFocus) {
            PIXI.sound.muteAll();
        }
    }

    /**
     * Trace to browser console.
     * @method log
     * @param s string which will be traced to browser console.
     * @return void
     */
    static log(s: string): void {
        if (DEBUG) {
            Logger.debugGroup("Focus", s);
        }
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/Utils/Focus.ts
 **/